import { useSyncExternalStore } from 'react';

const HOVER_QUERY = '(hover: hover) and (pointer: fine)';

function subscribe(onChange: () => void): () => void {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return () => undefined;
    }
    const mql = window.matchMedia(HOVER_QUERY);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
}

function getSnapshot(): boolean {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return true;
    }
    return window.matchMedia(HOVER_QUERY).matches;
}

function getServerSnapshot(): boolean {
    // Default to "has hover" on the server: desktop is the more common first
    // paint and lets the Tooltip variant render without a flash before
    // hydration corrects to the real device modality.
    return true;
}

/**
 * Returns `true` when the current input device supports a real hover state
 * (mouse / trackpad with a fine pointer) and `false` on touch-only devices.
 *
 * Used to switch overlays between hover-driven (Tooltip) and tap-driven
 * (Popover) variants without forking the call site. Backed by the same
 * `(hover: hover)` media query that Tailwind's `hover:` variant resolves to,
 * so the runtime decision matches the CSS behaviour.
 */
export function useHasHover(): boolean {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
